import React from 'react';
import Navbar from '../ui-components/Navbar';
import BottomNavigation from '../ui-components/BottomNavigation';

const HomeLayout = ({ children }) => {
  return (
    // width: 100%;
    // height: 100%;
    // display: grid;
    // grid-template-rows: max-content 1fr max-content;
    <div className="grid h-full w-full grid-rows-[max-content_1fr_max-content] flex-col overflow-hidden">
      <Navbar />
      <div className="overflow-y-auto">
        <main className="h-full">{children}</main>
      </div>
      <BottomNavigation />
    </div>
  );
};
export default HomeLayout;
